module.exports = __webpack_public_path__ + "assets/premium-f0fc6a91f19baf1005ef73301f03a1be.svg";